import { render, staticRenderFns } from "./PaginaImportaOneriPersonale.vue?vue&type=template&id=0903a237"
import script from "./PaginaImportaOneriPersonale.vue?vue&type=script&lang=js"
export * from "./PaginaImportaOneriPersonale.vue?vue&type=script&lang=js"
import style0 from "./PaginaImportaOneriPersonale.vue?vue&type=style&index=0&id=0903a237&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports